(function () {
  if (window.__bbAskBooted) return; window.__bbAskBooted = true;
  var ENDPOINT = "/apps/chat";
  var PDP = window.__BB_PDP || null;
  var BBA_ICON = window.__BB_ASK_ICON; /* set by the small inline script in the snippet (needs Liquid) */
  var PROMPTS = window.__BB_PDP_PROMPTS || ["About this product", "What fabric is this?", "What fit is this?", "Similar styles & patterns", "Bottoms to pair with this"];
  if (!PDP || !PDP.id) return;

  var wrap = document.getElementById("bba-wrap");
  var scrim = document.getElementById("bba-scrim");
  var panel = document.getElementById("bba-panel");
  var msgs = document.getElementById("bba-msgs");
  var input = document.getElementById("bba-inp");
  var greeted = false;

  // stable session id (so PDP chats log to D1 under one session)
  var SID_KEY = "bb_sid_v1", sid = "";
  try { sid = localStorage.getItem(SID_KEY) || ""; } catch (e) {}
  if (!sid) { sid = "pdp-" + Math.random().toString(36).slice(2) + Date.now().toString(36); try { localStorage.setItem(SID_KEY, sid); } catch (e) {} }
  // ── CHAT → SALE ATTRIBUTION: mark the cart so a guest order can be traced to this chat ──
  var cartToken = "", STAMP_KEY = "bb_stamped_v1";
  // 17 Oct 2026 (patch 77 part 1, his yes): our browser id + visit id go with each chat call, so a guest who proves
  // their phone in the chat is tied to this browser. bl-path.js owns both ids; this only reads them, never makes them.
  function blIds() {
    var b = "", v = "", re = /^[a-z0-9]{20}$/;
    try { b = localStorage.getItem("bl_bid") || ""; } catch (e) {}
    try { v = sessionStorage.getItem("bl_vid") || ""; } catch (e) {}
    return { b: re.test(b) ? b : "", v: re.test(v) ? v : "" };
  }
  function markCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.token) cartToken = String(c.token);
      var already = false;
      try { already = localStorage.getItem(STAMP_KEY) === sid; } catch (e) {}
      if (already || (c && c.attributes && c.attributes.bb_chat === sid)) return;
      return fetch("/cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { bb_chat: sid } })
      }).then(function () { try { localStorage.setItem(STAMP_KEY, sid); } catch (e) {} });
    }).catch(function () {});
  }
  var RKEY = "bb_reset_v1";
  function getReset() { try { return +(localStorage.getItem(RKEY) || 0) || 0; } catch (e) { return 0; } }
  function setReset(t) { try { localStorage.setItem(RKEY, String(t)); } catch (e) {} }
  (function () { // fresh chat right after login (old chats stay saved on the backend)
    var LKEY = "bb_li_v1", isLI = !!(window.__BB_CUSTOMER && (window.__BB_CUSTOMER.id || window.__BB_CUSTOMER.email)), wasLI = false;
    try { wasLI = localStorage.getItem(LKEY) === "1"; } catch (e) {}
    if (isLI && !wasLI) { setReset(Date.now()); try { localStorage.setItem("bba_rlog_v1", "[]"); } catch (e) {} }
    try { localStorage.setItem(LKEY, isLI ? "1" : "0"); } catch (e) {}
  })();
  // rich render-log (localStorage) so cards / order lists / login card / prompts are RESTORED on reload
  var RLKEY = "bba_rlog_v1";
  function loadRlog() { try { return JSON.parse(localStorage.getItem(RLKEY)) || []; } catch (e) { return []; } }
  var rlog = loadRlog();
  function pushRlog(e) { rlog.push(e); if (rlog.length > 16) rlog = rlog.slice(-16); try { localStorage.setItem(RLKEY, JSON.stringify(rlog)); } catch (x) {} }
  function clearRlog() { rlog = []; try { localStorage.setItem(RLKEY, "[]"); } catch (x) {} }
  function replayRlog() {
    history = [];
    rlog.forEach(function (e) {
      if (e.u) { userSay(e.t); history.push({ role: "user", text: e.t }); return; }
      if (!(e.c && chartSay(e.c))) botSay(e.t);
      history.push({ role: "assistant", text: e.t });
      if (e.o) renderOrders(e.o, e.m || {});
      if (e.p) renderProducts(e.p);
      if (e.l) renderLoginCard(e.l[0], e.l[1]);
      if (e.q) renderRecos(e.q);
    });
    history = history.slice(-16);
  }
  function loadHistory(cb) { fetch(ENDPOINT + "/history?session_id=" + encodeURIComponent(sid) + "&since=" + getReset()).then(function (r) { return r.json(); }).then(function (j) { cb((j && j.messages) || []); }).catch(function () { cb([]); }); }

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
  function inr(n) { return n == null ? "" : "₹" + Number(n).toLocaleString("en-IN"); }
  var SPARK = '<svg viewBox="0 0 24 24" fill="#141414"><path d="M12 2l2.2 6.3L21 10l-5.4 3.4L17 20l-5-3.6L7 20l1.4-6.6L3 10l6.8-1.7L12 2Z"/></svg>';

  // ---------- the "Ask us" chip (rendered by the theme section, or injected as fallback) ----------
  function wireChip(el) { if (el.__bbaWired) return; el.__bbaWired = true; el.addEventListener("click", openPanel); }
  function makeChip() {
    var b = document.createElement("button");
    b.type = "button"; b.className = "bba-askchip";
    b.setAttribute("aria-label", "Ask Basics about this product");
    // 2026-10-06 (Clarity problem 8): the 213 KB animation was the biggest file on product pages and loaded
    // before the product photo. The chip shows at once; its picture fills in after the page has loaded.
    b.innerHTML = '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="" width="30" height="30"><span class="bba-asklbl">Ask me</span>';
    var im = b.querySelector("img");
    var fill = function () { im.src = BBA_ICON; };
    if (document.readyState === "complete") fill(); else window.addEventListener("load", fill);
    b.setAttribute("title", "Ask about this product");
    wireChip(b);
    return b;
  }
  function mountChip() {
    // 1) chip(s) rendered server-side by the theme section → just wire the click
    var existing = document.querySelectorAll(".bba-askchip");
    if (existing.length) { existing.forEach(wireChip); return true; }
    // 2) abtest variant: inline chip in the "Select your size" flex row
    var inline = document.querySelector(".bpdp-absize__chart");
    if (inline) { inline.insertAdjacentElement("afterend", makeChip()); return true; }
    // 3) generic: a centered row after the size-chart trigger / size grid
    var anchor = document.querySelector(".bpdp-size-chart-link") || document.querySelector("[data-bpdp-size-chart-trigger]") ||
      document.querySelector(".bpdp-absize__labelrow") || document.querySelector("[data-bpdp-absize-grid]") ||
      document.querySelector(".bpdp-size-cells") || document.querySelector(".bpdp-sizes");
    if (anchor) { var row = document.createElement("div"); row.className = "bba-askrow"; row.appendChild(makeChip()); anchor.insertAdjacentElement("afterend", row); return true; }
    return false;
  }
  function fallbackMount() {
    if (document.querySelector(".bba-askchip")) return;
    // last resort so the chip is NEVER missing — drop it at the top of the product form / buy area
    var host = document.querySelector('form[action*="/cart/add"]') || document.querySelector(".bpdp-buy") || document.querySelector(".product-form") || document.querySelector("main");
    if (host) { var row = document.createElement("div"); row.className = "bba-askrow"; row.appendChild(makeChip()); host.insertBefore(row, host.firstChild); }
  }
  function watchForAnchor() {
    if (mountChip()) return;
    var tries = 0;
    var obs = new MutationObserver(function () { if (mountChip() || ++tries > 600) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} if (!mountChip()) fallbackMount(); }, 8000);
  }
  /* chip re-enabled 2026-09-01: a robot-icon chip mounts next to the PDP size chart and opens the drawer via window.BBAsk.open(); PDP has NO floating launcher. */
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchForAnchor); else watchForAnchor();

  // ---------- panel open/close ----------
  function openPanel() {
    wrap.classList.add("bba-open");
    document.documentElement.classList.add("bbc-active");
    bbaFloaters(true);
    if (!greeted) {
      greeted = true;
      if (rlog && rlog.length) { replayRlog(); }
      else loadHistory(function (msgs) {
        if (msgs && msgs.length) { history = []; msgs.forEach(function (m) { m.role === "user" ? userSay(m.text) : botSay(m.text); history.push({ role: m.role, text: m.text }); }); history = history.slice(-16); }
        else { renderGreeting(); }
      });
    }
    setTimeout(function () { input.focus(); }, 300);
  }
  function closePanel() { wrap.classList.remove("bba-open"); document.documentElement.classList.remove("bbc-active"); bbaFloaters(false); }
  function resetChat() { setReset(Date.now()); msgs.innerHTML = ""; history = []; clearRlog(); renderGreeting(); }
  document.getElementById("bba-close").onclick = closePanel;
  document.getElementById("bba-reset").onclick = resetChat;
  scrim.onclick = closePanel;
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && wrap.classList.contains("bba-open")) closePanel(); });

  function renderGreeting() {
    var g = document.createElement("div"); g.className = "bba-greet";
    g.textContent = "Hi! I'm your BasicsLife Assistant 👋 Ask me anything about the “" + PDP.title + "” — fabric, fit, similar styles, pairing — or search our whole store, delivery, returns and sizing.";
    msgs.appendChild(g);
    var s = document.createElement("div"); s.className = "bba-sugg";
    PROMPTS.forEach(function (label) { var b = document.createElement("button"); b.innerHTML = SPARK + " " + esc(label); b.onclick = function () { send(label); }; s.appendChild(b); });
    msgs.appendChild(s); scroll();
    twinPrompt(s);
  }
  /* 27 Oct (#46, his yes): on a shirt page, add "Half sleeve version" / "Full sleeve version" when the same design
     (same groupcode tag + same COLOUR) in the other sleeve is IN STOCK. Asked only when the chat opens, from the
     theme's /collections/all/<groupcode>?view=bl-twin list, so shoppers who never open the chat pay nothing.
     The chat already answers the tap (twin card + sizes). */
  function twinPrompt(s) {
    try {
      if (String(PDP.type || "").toLowerCase() !== "shirts" || !window.fetch) return;
      var tg = PDP.tags || [], tag = function (k) { for (var i = 0; i < tg.length; i++) { var t = String(tg[i]); if (t.toLowerCase().indexOf(k) === 0) return t.slice(k.length).trim().toLowerCase(); } return ""; };
      var gc = tag("groupcode:"), co = tag("colour:"), half = /half|short/.test(tag("style:"));
      if (!gc) return;
      fetch("/collections/all/" + encodeURIComponent("groupcode:" + gc) + "?view=bl-twin", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (list) {
          var tw = (list || []).filter(function (p) { return p.h !== PDP.handle && p.a && /half|short/.test(p.s) !== half && p.c === co; })[0];
          if (!tw || !s.parentNode || s.querySelector(".bba-twin")) return;
          var label = half ? "Full sleeve version" : "Half sleeve version";
          var b = document.createElement("button"); b.className = "bba-twin"; b.innerHTML = SPARK + " " + esc(label); b.onclick = function () { send(label); };
          s.insertBefore(b, s.children[1] || null);
        })
        .catch(function () {});
    } catch (e) {}
  }

  function scroll() { msgs.scrollTop = msgs.scrollHeight; }
  /* 27 Oct (#47): phone numbers + email tappable, same rules as bb-chat.js linkify (links parked first; phones only when written like a phone). */
  function linkify(t) {
    var p = [], keep = function (h) { p.push(h); return "@@BBL" + (p.length - 1) + "@@"; };
    t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_, x, u) { return keep('<a href="' + u + '" target="_blank" rel="noopener">' + x + '</a>'); });
    t = t.replace(/(https?:\/\/[^\s<]+)/g, function (u) { return keep('<a href="' + u + '" target="_blank" rel="noopener">' + u.replace(/^https?:\/\//, "") + '</a>'); });
    t = t.replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, function (e) { return keep('<a href="mailto:' + e + '">' + e + '</a>'); });
    t = t.replace(/(^|[^\d+])(\+91[\s-]?[6-9]\d{4}[\s-]?\d{5}|\+91[\s-]?[6-9]\d{9}|1800[\s-]?\d{3,4}[\s-]?\d{3,4}|0\d{2,4}[\s-]\d{3,4}[\s-]\d{4}|[6-9]\d{4}[\s-]\d{5})(?!\d)/g, function (_, a, n) { return a + keep('<a href="tel:' + n.replace(/[^\d+]/g, "") + '">' + n + '</a>'); });
    return t.replace(/@@BBL(\d+)@@/g, function (_, i) { return p[+i]; });
  }
  function renderOrders(orders, meta) {
    if (!orders || !orders.length) return;
    orders.forEach(function (o) {
      var st = String(o.status || "").toUpperCase();
      var cls = (/FULFILLED|DELIVERED|COMPLETE/.test(st) && !/UN|PARTIAL/.test(st)) ? "green" : /UN|PENDING|PROCESS|OPEN/.test(st) ? "amber" : "grey";
      var items = (o.items || []).slice(0, 4).map(function (it) { return '<div class="bba-oi">' + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : "") + "<span>" + esc(it.title) + " ×" + (it.qty || 1) + "</span></div>"; }).join("");
      var view = o.url ? '<a class="bba-oact" href="' + esc(o.url) + '" target="_blank" rel="noopener">View order</a>' : "";
      var trk = o.tracking && (o.tracking.url || o.tracking.number) ? '<a class="bba-oact" href="' + esc(o.tracking.url || "#") + '" target="_blank" rel="noopener">Track</a>' : "";
      var el = document.createElement("div"); el.className = "bba-ord";
      el.innerHTML = '<div class="bba-ord-h"><b>Order ' + esc(o.name) + '</b><span class="bba-ost ' + cls + '">' + esc(o.status) + '</span></div><div class="bba-ord-sub">' + esc(o.date) + (o.total ? " · ₹" + Number(o.total).toLocaleString("en-IN") : "") + (o.payment ? " · " + esc(o.payment) : "") + "</div>" + items + '<div class="bba-ord-actions">' + view + trk + "</div>";
      msgs.appendChild(el);
    });
    if (meta && meta.moreUrl) { var m = document.createElement("a"); m.className = "bba-more"; m.href = meta.moreUrl; m.textContent = (meta.moreLabel || "View all orders") + " →"; msgs.appendChild(m); }
    scroll();
  }
  function botSay(t) { var d = document.createElement("div"); d.className = "bba-b bba-a"; d.innerHTML = linkify(esc(t)); msgs.appendChild(d); scroll(); return d; }
  // the worker's size chart (j.chart) as a table; his size row (highlight) bold. false → caller shows the text instead.
  function chartSay(c) {
    if (!c || !c.columns || !c.columns.length || !c.rows || !c.rows.length) return false;
    var hl = String(c.highlight || "").toUpperCase();
    var d = document.createElement("div"); d.className = "bba-b bba-a bba-chart";
    d.innerHTML = "<b>" + esc(c.title || "Size chart") + "</b>" + (c.unit ? ", " + esc(c.unit) : "") +
      '<div class="bba-tw"><table><thead><tr>' + c.columns.map(function (h) { return "<th>" + esc(h) + "</th>"; }).join("") + "</tr></thead><tbody>" +
      c.rows.map(function (r) { var s = String(r[0]).split("/")[0].trim().toUpperCase(); return "<tr" + (hl && s === hl ? ' class="hl"' : "") + ">" + r.map(function (x) { return "<td>" + esc(x) + "</td>"; }).join("") + "</tr>"; }).join("") +
      "</tbody></table></div>" + (c.note ? "<small>" + esc(c.note) + "</small>" : "");
    msgs.appendChild(d); scroll(); return true;
  }
  // per-answer feedback ("Are you OK with this answer?") -> worker (answer_feedback) for admin review.
  // Appended AFTER the product cards, BEFORE the recommendation chips; prominent OK / Not OK buttons.
  function attachThumbs(ctx) {
    try {
      var row = document.createElement("div"); row.className = "bba-fb";
      row.innerHTML = '<div class="bba-fb-q">Are you OK with this answer?</div><div class="bba-fb-btns"><button class="bba-fbb" type="button" data-r="up" aria-label="OK" title="OK">👍</button><button class="bba-fbb" type="button" data-r="down" aria-label="Not OK" title="Not OK">👎</button></div>';
      var bs = row.querySelectorAll(".bba-fbb"), done = false;
      for (var i = 0; i < bs.length; i++) { (function (b) { b.onclick = function () {
        if (done) return; done = true; var r = b.getAttribute("data-r");
        try { fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ feedback: { rating: r, answer: ctx.answer, question: ctx.question, qtype: ctx.qtype }, session_id: sid, customer: window.__BB_CUSTOMER || null }) }); } catch (e) {}
        for (var k = 0; k < bs.length; k++) { bs[k].disabled = true; if (bs[k] !== b) bs[k].classList.add("bba-fb-dim"); }
        b.classList.add("bba-fb-on");
        var qEl = row.querySelector(".bba-fb-q"); if (qEl) qEl.textContent = "Thanks for your feedback!";
        scroll();
      }; })(bs[i]); }
      msgs.appendChild(row); scroll();
    } catch (e) {}
  }
  function userSay(t) { var d = document.createElement("div"); d.className = "bba-b bba-u"; d.textContent = t; msgs.appendChild(d); scroll(); }
  function typing(on) { var ex = msgs.querySelector("#bba-typ"); if (on) { if (ex) return; var d = document.createElement("div"); d.id = "bba-typ"; d.className = "bba-typing"; d.innerHTML = "<i></i><i></i><i></i>"; msgs.appendChild(d); scroll(); } else if (ex) ex.remove(); }
  function toast(m) { var t = document.createElement("div"); t.className = "bba-toast"; t.textContent = m; document.body.appendChild(t); requestAnimationFrame(function () { t.classList.add("show"); }); setTimeout(function () { t.classList.remove("show"); setTimeout(function () { t.remove(); }, 250); }, 1600); }

  // ---------- product cards + add to cart ----------
  function card(p) {
    var el = document.createElement("div"); el.className = "bba-card";
    el.innerHTML =
      '<a class="bba-imgw" href="' + esc(p.url) + '"><img loading="lazy" src="' + esc(p.image_url) + '" alt="' + esc(p.title) + '"></a>' +
      '<div class="bba-cb"><a href="' + esc(p.url) + '" class="bba-ct">' + esc(p.title) + '</a>' +
      '<div class="bba-pr">' + inr(p.price) + (p.compareAtPrice ? ' <s>' + inr(p.compareAtPrice) + '</s>' : '') + '</div></div>';
    return el;
  }
  function renderProducts(products) {
    if (!products || !products.length) return;
    var w = document.createElement("div"); w.className = "bba-rail";
    products.forEach(function (p) { w.appendChild(card(p)); });
    msgs.appendChild(w); scroll();
    // images load async → re-scroll as they arrive so the rail isn't left below the fold; hide broken images
    w.querySelectorAll("img").forEach(function (im) {
      im.addEventListener("load", scroll);
      im.addEventListener("error", function () { var wrap = this.closest(".bba-imgw"); if (wrap) wrap.style.display = "none"; });
    });
    setTimeout(scroll, 120);
  }
  function renderRecos(qs) {
    if (!qs || !qs.length) return;
    var w = document.createElement("div"); w.className = "bba-recos";
    qs.forEach(function (q) { var b = document.createElement("button"); b.type = "button"; b.textContent = q; b.onclick = function () { send(q); }; w.appendChild(b); });
    msgs.appendChild(w); scroll();
  }
  function safeLoginUrl(u) {
    var ret = "return_url=" + encodeURIComponent(location.pathname + location.search);
    if (u && typeof u === "string" && u.charAt(0) === "/" && u.charAt(1) !== "/") return u.indexOf("return_url=") > -1 ? u : u + (u.indexOf("?") > -1 ? "&" : "?") + ret;
    return "/account/login?" + ret;
  }
  function renderLoginCard(url, text) {
    var el = document.createElement("div"); el.className = "bba-login";
    var body = document.createElement("div"); body.className = "bba-login-body";
    body.innerHTML = "<b>" + esc(text || "Log in to track your orders") + "</b><span>Sign in to see your orders and get tailored picks.</span>";
    var a = document.createElement("a"); a.className = "bba-login-btn"; a.href = safeLoginUrl(url); a.textContent = "LOG IN";
    el.appendChild(body); el.appendChild(a);
    msgs.appendChild(el); scroll();
  }
  // hide third-party floating widgets (WATI / Shop / Google review / etc.) while the chat is open
  var _bbaFloat = [];
  function bbaFloaters(hide) {
    try {
      if (hide) {
        _bbaFloat = [];
        document.querySelectorAll("div,iframe,aside,section,a[href]").forEach(function (n) {
          if (n.closest("#bba-wrap") || n.closest("#bba-launch") || n.id === "bbc-panel" || n.id === "bbc-bubble" || n.id === "bbc-toast") return;
          if (typeof n.className === "string" && /bba-|bbc-/.test(n.className)) return;
          var cs = getComputedStyle(n);
          if (cs.position !== "fixed" || cs.display === "none" || cs.visibility === "hidden") return;
          var r = n.getBoundingClientRect();
          if (r.width < 8 || r.height < 8 || r.width > 260 || r.height > 260) return; // skip tiny + big (headers/panels)
          var z = parseInt(cs.zIndex) || 0;
          var edge = r.right > window.innerWidth - 175 || r.bottom > window.innerHeight - 230 || r.left < 175;
          if (edge || z >= 40) { _bbaFloat.push([n, n.style.visibility, n.style.pointerEvents]); n.style.visibility = "hidden"; n.style.pointerEvents = "none"; }
        });
      } else {
        _bbaFloat.forEach(function (x) { x[0].style.visibility = x[1] || ""; x[0].style.pointerEvents = x[2] || ""; });
        _bbaFloat = [];
      }
    } catch (e) {}
  }
  function sizeOptIdx(prod) { var o = prod.options || []; for (var i = 0; i < o.length; i++) { var nm = (o[i] && o[i].name) || o[i]; if (/size|waist/i.test(nm)) return i; } return o.length - 1; }
  function startAdd(p, el, btn) {
    btn.disabled = true; btn.textContent = "…";
    fetch("/products/" + encodeURIComponent(p.handle) + ".js").then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (prod) {
        var variants = (prod.variants || []).filter(Boolean), avail = variants.filter(function (v) { return v.available; });
        if (!avail.length) { btn.textContent = "SOLD OUT"; btn.disabled = true; return; }
        if (variants.length === 1) { doAdd(avail[0].id, el, btn, p); return; }
        var idx = sizeOptIdx(prod), w = el.querySelector(".bba-sizes"), seen = {}, html = '<span class="bba-sizelbl">Select your size:</span>';
        variants.forEach(function (v) { var sz = v["option" + (idx + 1)] || v.title; if (seen[sz]) return; seen[sz] = 1; html += '<button class="bba-size' + (v.available ? '' : ' oos') + '" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(sz) + '</button>'; });
        w.innerHTML = html; w.hidden = false; btn.style.display = "none";
        w.querySelectorAll(".bba-size:not(.oos)").forEach(function (sb) { sb.onclick = function () { doAdd(Number(sb.getAttribute("data-vid")), el, btn, p, sb); }; });
        scroll();
      })
      .catch(function () { if (p.variantId) doAdd(Number(p.variantId), el, btn, p); else { btn.disabled = false; btn.textContent = "TRY AGAIN"; } });
  }
  function doAdd(vid, el, btn, p, sizeBtn) {
    if (sizeBtn) sizeBtn.textContent = "…";
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        var w = el.querySelector(".bba-sizes"); if (w) { w.hidden = true; w.innerHTML = ""; }
        btn.style.display = ""; btn.disabled = true; btn.textContent = "✓ ADDED";
        var added = el.querySelector(".bba-added"); if (added) added.hidden = false;
        toast("Added to cart"); refreshCart(); markCart(); scroll();
      })
      .catch(function () { if (sizeBtn) sizeBtn.textContent = "retry"; else { btn.style.display = ""; btn.disabled = false; btn.textContent = "TRY AGAIN"; } });
  }
  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      var n = String(c.item_count);
      try { document.querySelectorAll("[data-cart-count], .cart-count, #CartCount, .js-cart-count, .cart-link__count, .cart-count-bubble span[aria-hidden='true']").forEach(function (e) { e.textContent = n; }); } catch (x) {}
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: c } }));
    }).catch(function () {});
  }

  // ---------- send ----------
  // Came here from a store page (Changes to make #40, 14 Oct 2026): store pages write localStorage bl_store
  // {c: store code, t: ms} on a product tap; for 3 hours the chat sends store_code and the worker answers
  // in "Ask this store" mode. undefined → JSON leaves the field out.
  function fromStore() {
    try { var s = JSON.parse(localStorage.getItem("bl_store") || "null");
      if (s && /^[A-Z0-9]{2,4}$/.test(String(s.c)) && Date.now() - Number(s.t) < 3 * 3600 * 1000) return String(s.c); } catch (e) {}
    return undefined;
  }
  var history = [];
  function send(text) {
    text = (text || input.value || "").trim(); if (!text) return;
    if (!cartToken) markCart();
    if (!wrap.classList.contains("bba-open")) openPanel();
    input.value = ""; userSay(text); typing(true);
    var prior = history.slice(-6);
    history.push({ role: "user", text: text }); pushRlog({ u: 1, t: text });
    fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ message: text, product: PDP, history: prior, customer: window.__BB_CUSTOMER || null, session_id: sid, cart_token: cartToken, store_code: fromStore(), b: blIds().b, v: blIds().v }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        typing(false);
        var msg = j.ai_message || "Here's what I found.";
        if (!(j.chart && chartSay(j.chart))) botSay(msg);   // the table replaces the text chart; msg stays in history
        history.push({ role: "assistant", text: msg }); if (history.length > 16) history = history.slice(-16);
        if (j.orders) renderOrders(j.orders, j);
        renderProducts(j.products);
        if (j.loginCard) renderLoginCard(j.loginUrl, j.loginCardText);
        attachThumbs({ question: text, answer: msg, qtype: j.query_type });
        if (j.recommendedQuestions) renderRecos(j.recommendedQuestions);
        pushRlog({ t: msg, c: j.chart || null, o: j.orders || null, m: (j.moreUrl ? { moreUrl: j.moreUrl, moreLabel: j.moreLabel } : null), p: j.products || null, l: (j.loginCard ? [j.loginUrl, j.loginCardText] : null), q: j.recommendedQuestions || null });
      })
      .catch(function () { typing(false); botSay("Sorry — I had trouble just now. Mind trying again?"); });
  }
  document.getElementById("bba-send").onclick = function () { send(); };
  input.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });

  window.BBAsk = { open: openPanel, close: closePanel };
})();
